module.exports = __webpack_public_path__ + "img/img-3-14mobile.ee2ffb94.webp";